import { Combobox } from '@headlessui/react'
import classNames from 'classnames'
import { ChevronToggle } from 'app/components/ChevronToggle'

type ComboButtonProps = {
  inputClassName?: string
  setButton: (element: HTMLButtonElement | null) => void
  onButtonClick?: () => void
  customIcon?: React.ReactNode
  children: React.ReactNode
  chevronClassName?: string
  onBlur?: () => void
  referenceProps: Record<string, unknown>
  disabled?: boolean
}

export function ComboButton({
  inputClassName,
  setButton,
  onButtonClick,
  customIcon,
  children,
  chevronClassName,
  onBlur,
  referenceProps,
  disabled,
}: ComboButtonProps) {
  return (
    <Combobox.Button
      as="div"
      data-testid="combo-button"
      className={classNames(`combobox-button`, inputClassName)}
      ref={setButton}
      onBlur={() => onBlur?.()}
      onClick={() => {
        onButtonClick?.()
      }}
      {...referenceProps}
    >
      {({ open }) => (
        <>
          {customIcon && <span className="flex items-center">{customIcon}</span>}

          <div className={classNames({ [`!ml-2 !pr-4`]: customIcon }, `flex w-3/4 items-center`)}>{children}</div>

          {!disabled && (
            <div className="stuff-on-the-right absolute inset-y-0 right-0 flex items-center rounded-r-md">
              <ChevronToggle className={chevronClassName} open={open} />
            </div>
          )}
        </>
      )}
    </Combobox.Button>
  )
}
